import { type Row, flexRender } from '@tanstack/react-table'

import { themeHoverBackgroundMap } from '@mntn-dev/ui-theme'

import { cn } from '@mntn-dev/ui-utilities'
import type { RowType } from './table-row.tsx'
import { Table } from './table.tsx'

export type DataTableRowProps<T> = {
  row: Row<T>
  data: T
  rowIdentifier: string
  onClick?: () => void
}

export const DataTableRow = <T,>({
  row,
  data,
  rowIdentifier,
  onClick,
}: DataTableRowProps<T>) => (
  <Table.Row
    key={row.id}
    dataTestId={`${rowIdentifier}-${(data as RowType)[rowIdentifier]}`}
    onClick={onClick}
    className={cn('h-18', themeHoverBackgroundMap.tertiary)}
  >
    {row.getVisibleCells().map((cell) => (
      <Table.Cell
        key={cell.id}
        className={cell.column.columnDef.meta?.className || ''}
      >
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </Table.Cell>
    ))}
  </Table.Row>
)
